import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { MarketsFilters, MarketSlice } from "./marketTypes.ts";

const initialState: MarketSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "name",
    order: "asc",
  },
};

export const marketsSlice = createSlice({
  name: "markets",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<MarketSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<MarketSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof MarketsFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<MarketSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  marketsSlice.actions;

export const selectPage = (state: RootState) => state.markets.page;
export const selectRowsPerPage = (state: RootState) =>
  state.markets.rowsPerPage;
export const selectFilter = (state: RootState) => state.markets.filter;
export const selectSort = (state: RootState) => state.markets.sort;

export default marketsSlice.reducer;
